<template>
    <div id="edit_role">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div class="contents" v-if="is_initialized">
            <div v-if="is_loading" class="ui active centered inline loader"></div>
            <div class="ui form" v-else>
                <div class="field">
                    <label>{{ $t('models.attributes.roles.name') }}</label>
                    <input type="text" class="name" v-model="role.name">
                </div>

                <div is="PermissionsTable" :role="role"></div>

                <div class="ui basic positive button" @click="update_role">
                    {{ $t('ui.general.submit') }}
                </div>
                <router-link :to="{name: 'roles'}" class="ui basic button">
                    <i class="undo icon"></i>
                    {{ $t('ui.general.back') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
import PermissionsTable from './permissions_table.vue'
export default {
    name: "EditRole",
    data: function () {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
            role: {},
        }
    },
    computed: {
    },
    created: function() {
    },
    mounted: function() {
        this.init();
    },
    methods: {
        init: async function() {
            var that = this;
            await new Promise(resolve => {
                that.is_initialized = false;
                resolve();
            });
            await that.fetch_role();
            await new Promise(resolve => {
                that.is_loading = false;
                that.is_initialized = true;
                resolve();
            });
        },
        fetch_role: function() {
            var that = this;

            var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_role).parse({
                "identity": that.$route.params.identity,
            });
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        that.role = response.data.role;
                    } else {
                        console.log(response.data);
                        // that.$noty.error('無法取得職位');
                        that.$noty.error(
                            that.$t('ui.notifications.error.fetch__name', {
                                name: that.$t('models.roles'),
                            })
                        );
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    // that.$noty.error('取得職位失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.fetch__name', {
                            name: that.$t('models.roles'),
                            reason: ': ' + error
                        })
                    );
                });
        },
        update_role: function() {
            var that = this;

            var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_role_update).parse({
                "identity": that.$route.params.identity,
            });

            that.errors = [];
            that.is_loading = true;
            axios.post(url, that.role, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        // that.$noty.success('編輯職位成功');
                        that.$noty.success(
                            that.$t('ui.notifications.success.update__name', {
                                name: that.$t('models.roles')
                            })
                        );
                        that.$store.dispatch('provider/fetch_current_staff');
                        that.$store.dispatch('provider/fetch_current_staff_permissions');
                        that.$router.push({name: "roles"});
                    } else {
                        console.log(reponse.data);
                        // that.$noty.error('無法更新職位');
                        that.$noty.error(
                            that.$t('ui.notifications.error.update__name', {
                                name: that.$t('models.roles')
                            })
                        );
                    }
                })
                .catch(function (error) {
                    console.log(error.reponse);
                    // that.$noty.error('更新職位失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.update__name', {
                            name: that.$t('models.roles')
                        })
                    );
                })
                .then(function() {
                    setTimeout(function () {
                        that.is_loading = false;
                    }, 300);
                });

        }
    },
    components: {
        PermissionsTable,
        ErrorMessages,
    }
}

function sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds){
            break;
        }
    }
}
</script>
